import Chip from '@mui/material/Chip';
import type { Delivery } from '../api/draftsApi';

const DELIVERY = {
  queued: { label: 'Queued', color: 'default' },
  sent: { label: 'Sent', color: 'info' },
  delivered: { label: 'Delivered', color: 'success' },
  read: { label: 'Read', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
} as const;

export function DeliveryStatusChip({ status }: { status: Delivery['status'] }) {
  return <Chip label={DELIVERY[status].label} color={DELIVERY[status].color} />;
}
